import React, {useState} from 'react'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import {contactUsStyles} from './index.style'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {useEffect} from 'react'

function ContactUs({breadcrumbData, setBreadcrumbData}) {
    const [iframeHeight, setIframeHeight] = useState(null)
    useEffect(() => {
        if (!breadcrumbData || !Object.keys(breadcrumbData).length) {
            setBreadcrumbData({
                parentFolder: {
                    folderId: 'customer-service',
                    folderName: 'Customer Service',
                    url: '/help/'
                },
                contentFolder: {
                    folderId: 'customer-service',
                    folderName: 'Contact Us',
                    url: '/contactus/'
                }
            })
        }
    }, [])

    useEffect(() => {
        const handleMessage = (event) => {
            // You can add origin checking here for security
            if (event.data?.type === 'form-stack-frame-resize' && event.data?.height) {
                setIframeHeight(`${event.data.height}px`)
            }
        }

        window.addEventListener('message', handleMessage)

        return () => {
            window.removeEventListener('message', handleMessage)
        }
    }, [])

    return (
        <Box sx={contactUsStyles}>
            <Text as="h1" textAlign="center">
                <FormattedMessage
                    defaultMessage="Contact Us"
                    id="customer.service.contactus.label"
                />
            </Text>
            <Box
                id="contact_us_web_form"
                as="iframe"
                src="https://cavenders.formstack.com/forms/contact_us_web_form"
                allowFullScreen
                w="full"
                height={iframeHeight || ['2060px', '2060px', '1660px']}
            />
        </Box>
    )
}

ContactUs.propTypes = {
    setBreadcrumbData: PropTypes.func,
    breadcrumbData: PropTypes.object
}

export default ContactUs
